import React, { useState, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Input, TextArea, Checkbox, MaskedTextBox } from "@progress/kendo-react-inputs";
import { Form, FormElement, Field } from "@progress/kendo-react-form";

import { utils } from "../../services/helpers/utils";
import { CustomDropdown } from "../shared/customDropdown";
import { nomService } from "../../services/api/nom.service";
import { alertService } from "../../services/helpers/alert.service";
import { partnerService } from "../../services/api/partner.service";

export const PatientAdd = () => {

    const location = useLocation();
    const formRef = useRef();
    const navigate = useNavigate();

    const searchParams = new URLSearchParams(location.search);
    const cnp = searchParams.get("cnp") ?? "";

    const numeValidator = (value) => (value ? "" : "Completati campul nume!");
    const prenumeValidator = (value) => (value ? "" : "Completati campul prenume!");
    const cnpValidator = (value) => (value ? "" : "Completati campul CNP!");
    const telefonValidator = (value) => (value ? "" : "Completati campul telefon!");
    const emailValidator = (value) => (value ? "" : "Completati campul email!");
    const judetValidator = (value) => (value ? "" : "Completati campul judet!");

    


    const handleNoPhoneCheck = (event) => {
        if (event.value) {
            let formValues = formRef.current.values;
            if (formValues) {
                formValues.telefon = '0700000000'
            }
        }
    }

    const handleNoEmailCheck = (event) => {
        let formValues = formRef.current.values;
        if (formValues) {
            formValues.email = 'nuare@reginamaria.ro'
        }
    };



    const handleSubmit = (data) => {
        // Procesează datele din formular

        if (!utils.isCNPValid(data.cnp)) {
            alertService.success('CNP-ul este invalid!'); return;
        }

        if (utils.datefromCNP(data.cnp) > new Date() ){
            alertService.success('Data nasterii este in viitor!'); return;
        };

        
        let patient = {
            id: 0,
            nume: data.nume,
            prenume: data.prenume,
            cnp: data.cnp,
            email: data.email,
            telefon: data.telefon,
            judet: data?.judet?.id,
            adresa: data.adresa ?? "",
            nota: data.nota ?? "",
        }
		


		
        partnerService.savePatient(patient).then(response => {
            if (response) {
                alertService.success("Pacientul a fost salvat cu succes!");
            }
        });

    };

    const handleClose = () => {

        navigate("/dashboard/cautare-pacient");
    }


    return (
        <>
            <h2 className="titlu mt20">Adauga pacient</h2>
            <Form
                ref={formRef}
                initialValues={{cnp: cnp}}

                onSubmit={handleSubmit}
                render={(formRenderProps) => (
                    <FormElement style={{ maxWidth: 950 }}>
                    <div className="formular">
                        <fieldset className="mt10 mb20">

                            <div className="clearfix">
                                <div className="fl">
                                        <label className="mt15 mb5">Nume <span className="red">*</span></label>
                                        <Field name="nume" component={Input} maxLength="25" className=" w420" validator={numeValidator} />

                                        <label className="mt15 mb5">Prenume <span className="red">*</span></label>
                                        <Field name="prenume" component={Input} maxLength="25" className=" w420" validator={prenumeValidator} />

                                        <label className="mt15 mb5">CNP <span className="red" >*</span></label>
                                        <Field name="cnp" component={Input} maxLength="13" className=" w420" validator={cnpValidator} />

                                        <label className="mt15 mb5">Nota</label>
                                        <Field name="nota" component={TextArea} className="w420" rows="6" />
                                </div>
                                <div className="fr">
                                        <label className="mt15 mb5">Telefon <span className="red">*</span></label>
                                        <Field name="telefon" component={MaskedTextBox} mask="0000-000-000" maxLength="12" className="w420"
                                            validator={telefonValidator} />

                                        <label className="mt15 mb5">Nu are telefon</label>
                                        <Field name="nu_are_tel" component={Checkbox} onChange={handleNoPhoneCheck} />

                                        <label className="mt15 mb5">E-mail <span className="red">*</span></label>
                                        <Field name="email" component={Input} maxLength="70" className=" w420" validator={emailValidator} />

                                        <label className="mt15 mb5">Nu are email</label>
                                        <Field name="nu_are_email" component={Checkbox} onChange={handleNoEmailCheck} />

                                        <label className="mt15 mb5">Judet <span className="red">*</span></label>
                                        <Field name="judet" component={CustomDropdown} className=" w420" request={nomService.getCounties} validator={judetValidator} />

                                        <label className="mt15 mb5">Adresa</label>
                                        <Field name="adresa" component={Input} className=" w420" />
                                </div>
                            </div>
                            <p className="paragraf red mt15">Campurile marcate cu * sunt obligatorii.</p>
                        </fieldset>
                    </div>
                    <div className="k-form-buttons">
                        <button type="submit" className="btn" disabled={!formRenderProps.allowSubmit}>Salveaza</button>
                        <button type="reset" className="btn ml10" onClick={ handleClose }>Inchide</button>
                    </div>
                    </FormElement>
                
                )}
            />
        </>
    );
}